import script from "./TextBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBlock.vue?vue&type=script&setup=true&lang=js"

import "./TextBlock.vue?vue&type=style&index=0&id=60c9dd20&lang=scss"

const __exports__ = script;

export default __exports__